export const AppColors = {
  appBg: "#3d3e3f",
  khushiPageBg: "#1a0a0e",
  dashboardBlue: "#054aac",
} as const;

